import { BaseService } from '../base/BaseService';
export class ProjectCustomFieldService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectCustomFieldService.DEFAULT_SERVICE_PATH,
            basePath: ProjectCustomFieldService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ── Definitions ──
    /** GET /api/project-custom-fields/definitions/type/{projectTypeId} */
    async getDefinitionsByType(projectTypeId) {
        const response = await this.http.get(this.buildUrl(`definitions/type/${projectTypeId}`));
        return response.data ?? [];
    }
    /** POST /api/project-custom-fields/definitions */
    createDefinition(def) {
        return this.http.post(this.buildUrl('definitions'), def);
    }
    /** PUT /api/project-custom-fields/definitions/{fieldDefId} */
    updateDefinition(fieldDefId, def) {
        return this.http.put(this.buildUrl(`definitions/${fieldDefId}`), def);
    }
    /** DELETE /api/project-custom-fields/definitions/{fieldDefId} */
    deleteDefinition(fieldDefId) {
        return this.http.delete(this.buildUrl(`definitions/${fieldDefId}`));
    }
    // ── Values ──
    /** GET /api/project-custom-fields/values/project/{projectId} */
    async getValuesByProject(projectId) {
        const response = await this.http.get(this.buildUrl(`values/project/${projectId}`));
        return response.data ?? [];
    }
    /** PUT /api/project-custom-fields/values/project/{projectId} — bulk upsert. */
    setValues(projectId, values) {
        return this.http.put(this.buildUrl(`values/project/${projectId}`), values);
    }
}
ProjectCustomFieldService.DEFAULT_SERVICE_PATH = 'projects';
ProjectCustomFieldService.BASE_PATH = 'api/project-custom-fields';
//# sourceMappingURL=ProjectCustomFieldService.js.map